import React from 'react';
import {COLORS} from '../../../../../constants/colors';
import {Icon} from '../../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../../atoms/Icon/IconName';
import {BasicControl} from './BasicControl';

export const PauseControl: React.FC<{
  pauseFunction: () => void;
}> = ({pauseFunction}) => {
  return (
    <BasicControl onClick={pauseFunction}>
      <Icon
        asset={GenericIconName.Pause}
        width={20}
        height={20}
        fillOpacity={0.6}
        strokeWidth={2}
        fill={COLORS.White}
      />
    </BasicControl>
  );
};
